module.exports = __webpack_public_path__ + "static/media/tile-10.1bc78d20.jpg";